<template>
  <div>
    <div class="d-flex">
      <div class="input-label w-lg-59" v-if="!value.isFromSenai">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Nome do curso</label
        >
        <input
          type="text"
          placeholder="Ex: Noções Básicas de Mecânica Automobilística"
          v-model="value.courseName"
        />
      </div>
      <div class="input-label w-lg-59" v-if="value.isFromSenai">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Nome do curso</label
        >
        <select-component
          classNames="select-size-big"
          id="curso-nome"
          valueKey="nome"
          placeholder="Selecionar nome do curso"
          :value.sync="courseItem"
          :valuesList="avaiableCourses"
        ></select-component>
      </div>
      <div
        class="
          input-label
          flex-md-row
          align-items-md-end
          justify-content-end
          mb-2
          ml-32
        "
      >
        <label class="switch mr-3">
          <input type="checkbox" v-model="value.isFromSenai" />
          <span class="slider round"></span>
        </label>
        <label class="body2 color-black mb-1">Realizado no SENAI</label>
      </div>
    </div>
    <div class="input-label">
      <label class="caption1 color-secondary-600 bold mb-2"
        >Onde você fez o curso?</label
      >
      <input type="text" placeholder="Nome da instituição" v-model="value.whereFromCourse" />
    </div>
    <div class="d-flex flex-column flex-md-row">
      <div class="input-label">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Selecione o tipo de curso</label
        >
        <select-component
          classNames="select-size-big"
          id="curso"
          valueKey="nome"
          placeholder="Selecionar tipo de curso"
          :value.sync="value.courseType"
          :valuesList="courseList"
        ></select-component>

      </div>
      <div class="input-label ml-md-32 w-100">
        <label class="caption1 color-secondary-600 bold mb-2">Quando você concluiu?</label>
        <datepicker v-model="value.dateFinished" :language="translationDatePicker" :clear-button="true"  input-class="datepicker w-100" placeholder="mês/ano" minimum-view="month" :format="DatePickerFormat"></datepicker>
      </div>
    </div>
    <div class="input-label">
      <label class="caption1 color-secondary-600 bold mb-2"
        >Fale um pouco sobre o curso e os aprendizados</label
      >
      <textarea
        name="w3review"
        rows="6"
        cols="50"
        placeholder="Descrição do curso"
        v-model="value.about"
      ></textarea>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {ptBR} from 'vuejs-datepicker/dist/locale'

import SelectComponent from '../shared/SelectComponent.vue';

export default {
  name: "FormationForm",
  props: ['value', 'avaiableCourses'],
  components: {
    Datepicker,
    SelectComponent
  },
  data() {
    return {
      courseItem: null,
      translationDatePicker: ptBR,
      DatePickerFormat: 'MM/yyyy',
      courseList: [
        {
          nome: 'Cursos de qualificação profissional'
        },
        {
          nome: 'Cursos técnico'
        },
        {
          nome: 'Cursos de graduação'
        },
        {
          nome: 'Pós-Graduação'
        },
      ]
    }
  },
  watch: {
    courseItem(val) {
      if (val) {
        this.value.courseName = val.nome;
      } else {
        this.value.courseName = ''
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!value) {
          return;
        }
        if(value.courseName && value.isFromSenai) {
          if (this.avaiableCourses.filter(e => e.nome === value.courseName).length > 0) {
            this.courseItem = {
              nome: value.courseName
            }
          }
        }
      }
    },
    "value.isFromSenai"(value) {
      if (value) {
        this.value.courseName = '';
      }
    }
  }
};
</script>

<style scoped>
</style>
